// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailK":"K_d2xDetailK__PaEhx"};